import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
// import moment from "moment";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllVesselsExportLoading = createAsyncThunk(
  "VesselsExportLoading/FindAllVesselsExportLoading",
  async (VesselsExportLoadingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VesselsExportLoading/FindAllVesselsExportLoading`,
        VesselsExportLoadingData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Vessels Export Loadings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVesselsExportLoading = createAsyncThunk(
  "VesselsExportLoading/InsertVesselsExportLoading",
  async (VesselsExportLoadingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VesselsExportLoading/InsertVesselsExportLoading`,
        VesselsExportLoadingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Vessels Export Loading:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVesselsExportLoading = createAsyncThunk(
  "VesselsExportLoading/UpdateVesselsExportLoading",
  async (VesselsExportLoadingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VesselsExportLoading/UpdateVesselsExportLoading`,
        VesselsExportLoadingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Vessels Export Loading:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVesselsExportLoading = createAsyncThunk(
  "VesselsExportLoading/DeleteVesselsExportLoading",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VesselsExportLoading/DeleteVesselsExportLoading`,
        { shipping_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Vessels Export Loading:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVesselsExportLoadingByID = createAsyncThunk(
  "VesselsExportLoading/FindByIDVesselsExportLoading",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VesselsExportLoading/FindByIDVesselsExportLoading`,
        { shipping_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        // form_type:result.form_type,
        id: result?.id,
        shipping_guid: result?.shipping_guid,
        at_jetty: result?.at_jetty,
        eta: result?.eta ? moment(result?.eta, "YYYY-MM-DD").toDate() : "",
        etd: result?.etd ? moment(result?.etd, "YYYY-MM-DD").toDate() : "",
        vessels_name: result?.vessels_name,
        agent_id: result?.agent_id
          ? result?.agent_id.split(",").map(Number)
          : [],
        agent_name: result?.agent_name,
        cargo: result?.cargo,
        next_port_id: result?.next_port_id,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Vessels Export Loading:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
